import { render, staticRenderFns } from "./AscAppLoadingTemplate.vue?vue&type=template&id=483e9dee&"
import script from "./AscAppLoadingTemplate.vue?vue&type=script&lang=js&"
export * from "./AscAppLoadingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscAppLoadingTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports